<template>
  <div class="chat-channel-container">
    <h3 class="text-center mb-2 font-base">{{ $t('chat_channels.title') }}</h3>

    <ul class="chat-channel-list">
      <li v-for="(channel, index) in channels" :key="index" @click="$emit('select', channel.value)">
        <component :is="channel.icon" class="icon-channel"></component>
        {{ channel.text }}
        <icon-chevron-right class="icon-arrow-right" />
      </li>
    </ul>
  </div>
</template>

<script>
import IconChevronRight from 'assets/icons/chevron-right.svg?inline'
import IconChat from 'assets/icons/chat.svg?inline'
import IconLineChannel from 'assets/icons/line-channel.svg?inline'
import IconMessengerChannel from 'assets/icons/messenger-channel.svg?inline'
import IconWhatsApp from 'assets/icons/whatsApp-logo.svg?inline'
import { ChatChannels } from 'javascript/Constants'
import { useSettingsStore } from 'Store/settings'

export default {
  name: 'SelectChatChannel',

  components: {
    IconChevronRight,
    IconChat,
    IconLineChannel,
    IconMessengerChannel,
    IconWhatsApp
  },

  setup() {
    return {
      settingsStore: useSettingsStore()
    }
  },

  computed: {
    channels() {
      return [
        {
          text: this.$t('chat_channels.facebook'),
          value: ChatChannels.MESSENGER,
          icon: 'IconMessengerChannel'
        },
        { text: this.$t('chat_channels.line'), value: ChatChannels.LINE, icon: 'IconLineChannel' },
        { text: this.$t('chat_channels.web'), value: ChatChannels.WEB, icon: 'IconChat' },
        { text: this.$t('chat_channels.whats_app'), value: ChatChannels.WHATSAPP, icon: 'IconWhatsApp' }
      ].filter((c) => this.settingsStore.availableChatChannels.includes(c.value))
    }
  }
}
</script>
